module.exports = __webpack_public_path__ + "assets/img/intro-vip-b1.fe68675a.jpg";